<ng-template #modalContainerCallDetails></ng-template>
<div class="loading" *ngIf="isLoading">
  <app-three-dots-blinking></app-three-dots-blinking>
</div>

<div class="assignment-section" *ngIf="!isLoading && assignment">
  <div class="header-outer">
    <qai-inner-wrap>
      <a
        class="header-title"
        href="/assignments"
        [routerLink]="'/assignments'"
        (click)="handleTitleClick()"
      >
        <qai-icon kind="chevron-left" size="24px" class="header-icon" />
        {{ assignment.moduleAssignmentName }}
      </a>
    </qai-inner-wrap>
  </div>

  <qai-inner-wrap class="content">
    <div class="calls">
      <!-- System Message -->
      <!--
      <div class="system-message">
        <div class="icon">
          <img src="assets/icons/alert-circle.svg">
        </div>
        <div class="title">
          <strong>Your assignment is past due. </strong>
          You now have until X date to finish.
        </div>
      </div>
      -->

      <!-- Call Details -->
      <div class="call-details" [class.ios-layout]="nativeCallService.isNativeIos" *ngFor="let call of assignment.callsWithinModuleAssignnment">
        <div class="row">
          <div class="call-data" [class.call-data-full]="!call.callThumbnail">
            <div class="title">{{ call.callName }}</div>
            <div class="sub-title">
              <span>{{call.callTypeTranslated }}</span>
              <!-- Estimated time -->
              <ng-container *ngIf="call.callInstruction">
                <span>•</span>
                <span>{{ call.callInstruction }}</span>
              </ng-container>
              <!-- Number of questions -->
              <ng-container *ngIf="call.numberOfQuestions && !call.visualAidEnabled">
                <span>•</span>
                <span>{{ call.numberOfQuestions }}</span>
                <span>{{'assignment.QUESTION' | transloco}}{{ call.numberOfQuestions > 1 ? 's': ''}}</span>
              </ng-container>
            </div>
            <div class="description">
              {{ call.callDescription }}
            </div>
          </div>
          <div class="call-image" *ngIf="call.callThumbnail">
            <img [noCacheSrc]="call.callThumbnail">
          </div>
        </div>

        <div class="row details-row">
          <!-- Status -->
          @if (!hideResultsForLearners) {
            <div class="col">
              <div class="text">
                <img src="assets/icons/bell-03.svg">
                {{'assignment.STATUS' | transloco}}
              </div>
              <ng-container *ngIf="call.statusBadge as statusBadge">
                <qai-badge
                  *ngIf="(this.nonOperationalAssignmentStatus || '').toLowerCase() === AppConstants.CLOSED_ASSIGNMENT_STATUS; else regularBadge"
                  kind="gray-blue-outline"
                  shape="rectangle"
                  class="closed-badge"
                  [label]="statusBadge.text">
                </qai-badge>
                <ng-template #regularBadge>
                  <div class="badge" [class]="statusBadge.class">
                    {{ statusBadge.text }}
                  </div>
                </ng-template>
              </ng-container>
            </div>
          }

          <!-- Score -->
          @if (!hideResultsForLearners) {
            <div class="col">
              <div class="text">
                <img src="assets/icons/file-heart-03.svg">
                  {{'assignment.SCORE' | transloco}}
                <small *ngIf="assignment.scoreCriteria > 0">{{'assignment.MUST_ACHIEVE' | transloco}} {{ localeService.formatNumber(assignment.scoreCriteria, localeService.getDecimalPlaces(assignment.scoreCriteria)) }} {{
                  assignment.scoreCriteria == 5 ? '' : ('assignment.OR_HIGHER' | transloco)
                  }}</small>
              </div>
              <div class="col">
                <div *ngIf="call.callScore && call.callScore > 0" class="badge" [ngClass]="{
                       'badge-success': call.callScore >= assignment.scoreCriteria,
                       'badge-warning': call.callScore >= assignment.scoreCriteria - 1 && call.callScore < assignment.scoreCriteria,
                       'badge-error': call.callScore < assignment.scoreCriteria - 1,
                       'badge-blue': assignment.moduleAssignmentType === typePractice && assignment.scoreCriteria === 0
                     }">
                  {{ localeService.formatNumber(call.callScore, localeService.getDecimalPlaces(call.callScore)) }} {{'assignment.OUT_OF_5' | transloco}}
                </div>

              </div>
            </div>
          }

          <!-- Last Attempt -->
          <div class="col">
            <div class="text attempts">
              <img src="assets/icons/clock-rewind.svg">
              {{'assignment.LATEST_ATTEMPT' | transloco}}
              <!-- If max number of attempts -->
              <small *ngIf="call.maxNumberOfAttempts && call.maxNumberOfAttempts > 0">
                {{ call.numberOfPreviousAttempts }} {{'assignment.TOTAL_ATTEMPTS' | transloco}}
              </small>
              <!-- If null max number of attempts -->
              <small *ngIf="!call.maxNumberOfAttempts || call.maxNumberOfAttempts === 0">
                {{'assignment.UNLIMITED' | transloco}}
              </small>
            </div>

            <div class="col" *ngIf="call.maxNumberOfAttempts">
              <div class="badge">
                {{ call.maxNumberOfAttempts - call.numberOfPreviousAttempts}} {{'assignment.REMAINING' | transloco}}
              </div>
            </div>
            <div class="col" *ngIf="!call.maxNumberOfAttempts">
              <div class="badge" *ngIf="call.recentCallAttemptDate">
                {{ call.recentCallAttemptDate }}
              </div>
            </div>
          </div>
        </div>

        <div class="call-details-footer">

          @if (!hideResultsForLearners) {
            <app-previous-results-button
              (click)="openPreviousResultsModal(call)"
              [count]="call.numberOfPreviousAttempts"
            />
          }

          <div class="call-details-footer-actions">
            <button qai-button [kind]="'tertiary'" [size]="'medium'" *ngIf="call.hasDetails" (click)="getCallDetails(call)">
             {{'assignment.VIEW_CALL_DETAILS' | transloco}}
            </button>

            <button qai-button [kind]="'primary'" [size]="'medium'" *ngIf="(this.nonOperationalAssignmentStatus || '').toLowerCase() !== AppConstants.CLOSED_ASSIGNMENT_STATUS"
              [disabled]="call.isMaxAttemptsReached || nonOperationalAssignmentStatus?.toLowerCase() === AppConstants.STAGED_ASSIGNMENT_STATUS"
              (click)="handleLaunchClick(call)"
              [matTooltip]="call.isMaxAttemptsReached ? ('assignment.MAX_ATTEMPTS_REACHED' | transloco) : ''"
              matTooltipClass="tooltip-dark">
              {{'assignment.LAUNCH_CALL' | transloco}}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="cards" [class.cards-system-msg]="displaySystemMessage">
      <!-- Due date -->
      <div class="card"
        *ngIf="assignment.moduleAssignmentDueDate && assignmentDaysLeft !== null && ((assignmentDaysLeft > 7) || (assignmentDaysLeft < 0 && isAssignmentFinished()))">
        <div class="row">
          <qai-glyph kind="calendar" spotlight="brand" size="48px" />
          <div class="data">
            <div class="title">
              {{'assignment.DUE_DATE' | transloco}}
            </div>
            <div class="description">
              {{ assignment.moduleAssignmentDueDate | localeDate:'date' }}
            </div>
          </div>
        </div>
      </div>

      <!-- Due date yellow-->
      <div class="card card-warning"
        *ngIf="assignment.moduleAssignmentDueDate && assignmentDaysLeft !== null && assignmentDaysLeft <= 7 && assignmentDaysLeft >= 0 && !isAssignmentFinished()">
        <div class="row">
          <qai-glyph kind="calendar-warning" spotlight="warning" size="48px" />
          <div class="data">
            <div class="title">
              {{'assignment.DUE_DATE' | transloco}}
            </div>
            <div class="description">
              {{ assignmentDaysLeft }} {{ assignmentDaysLeft > 1 ? ('assignment.DAYS' | transloco) : ('assignment.DAY' | transloco)}} {{'assignment.UNTILL_DUE' | transloco}}
            </div>
          </div>
        </div>
      </div>

      <!-- Due date red -->
      <div class="card card-error"
        *ngIf="assignment.moduleAssignmentDueDate && assignmentDaysLeft !== null && assignmentDaysLeft < 0 && !isAssignmentFinished()">
        <div class="row">
          <qai-glyph kind="calendar-error" spotlight="error" size="48px" />
          <div class="data">
            <div class="title">
              {{'assignment.DUE_DATE' | transloco}}
            </div>
            <div class="description">
              {{ -assignmentDaysLeft }} {{ -assignmentDaysLeft === 1 ? ('assignment.DAY' | transloco) : ('assignment.DAYS' | transloco)}} {{'assignment.PAST_DUE' | transloco}}</div>
            </div>
          </div>
        </div>

        <!-- Due date -->
        <div class="card" *ngIf="assignment.moduleAssignmentDueDate && assignmentDaysLeft === null">
          <div class="row">
            <qai-glyph kind="calendar" spotlight="brand" size="48px" />
            <div class="data">
              <div class="title">
               {{'assignment.DUE_DATE' | transloco}}
              </div>
              <div class="description">
              {{'assignment.ONGOING' | transloco}}
              </div>
            </div>
          </div>
        </div>

        <!-- Score Requirement -->
        <div class="card">
          @if (assignment.scoreCriteria > 0 && !hideResultsForLearners) {
            <!-- iOS: title in row, description full-width below -->
            @if (nativeCallService.isNativeIos) {
              <div class="row">
                <qai-glyph kind="heart-file" spotlight="brand" size="48px" />
                <div class="data">
                  <div class="title">
                    {{'assignment.SCORE_REQUIREMENT' | transloco}}
                  </div>
                </div>
              </div>
              <p class="score-description">
                {{'assignment.SCORE_REQUIREMENT_DETAIL' | transloco}} {{ localeService.formatNumber(assignment.scoreCriteria, localeService.getDecimalPlaces(assignment.scoreCriteria)) }}
                {{ assignment.scoreCriteria == 5 ? '' : ('assignment.OR_HIGHER' | transloco) }} {{'assignment.TO_COMPLETE_EACH_CALL' | transloco}}
              </p>
            } @else {
              <!-- Web: title + description side by side inside row -->
              <div class="row">
                <qai-glyph kind="heart-file" spotlight="brand" size="48px" />
                <div class="data">
                  <div class="title">
                    {{'assignment.SCORE_REQUIREMENT' | transloco}}
                  </div>
                  <div class="description">
                    {{'assignment.SCORE_REQUIREMENT_DETAIL' | transloco}} {{ localeService.formatNumber(assignment.scoreCriteria, localeService.getDecimalPlaces(assignment.scoreCriteria)) }}
                    {{ assignment.scoreCriteria == 5 ? '' : ('assignment.OR_HIGHER' | transloco) }} {{'assignment.TO_COMPLETE_EACH_CALL' | transloco}}
                  </div>
                </div>
              </div>
            }
          }

          <div class="card-list">
            <div class="sub-title">
              @if (nativeCallService.isNativeIos) {
                {{'assignment.COMPLETED_CALLS' | transloco}}
              } @else {
                {{'assignment.CALLS_IN_ASSIGNMENT' | transloco}}
              }
            </div>
            <div class="list" [class.ios-list]="nativeCallService.isNativeIos">

              <div class="item" *ngFor="let callItem of assignment.callsWithinModuleAssignnment">
                <div *ngIf="['CERTIFIED','COMPLETE'].includes(callItem.callStatus)" class="check"><img
                    src="assets/icons/check-3.svg"></div>
                @if (nativeCallService.isNativeIos && callItem.isIncompleteMessageVisible) {
                  <div class="check check-incomplete"></div>
                }
                @if (!['CERTIFIED','COMPLETE'].includes(callItem.callStatus) && !(nativeCallService.isNativeIos && callItem.isIncompleteMessageVisible)) {
                  <div class="check check-empty"></div>
                }
                <div class="item-text">
                  {{ callItem.callName }}
                  @if (callItem.isIncompleteMessageVisible) {
                    <div class="support-text">
                      @if (nativeCallService.isNativeIos) {
                        {{'assignment.NO_ATTEMPTS_LEFT' | transloco}}
                      } @else {
                        <span class="heavy">{{'assignment.INCOMPLETE_CALL' | transloco}}</span>
                        {{'assignment.MAX_ATTEMPTS_REACHED' | transloco}}
                      }
                    </div>
                  }
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- Certification -->
        <!--
      <div class="card">
        <div class="row">
          <div class="icon">
            <img src="assets/icons/certification.svg">
          </div>
          <div class="data">
            <div class="title">
              Certification
            </div>
            <div class="description">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </div>
            <div class="space"></div>
            <quant-button type="button" label="Learn More" hierarchy="link-color" size="sm"
              [disabled]="false"></quant-button>
          </div>
        </div>
      </div>
      -->

        <!-- Top Skills -->
        <!--
      <div class="card">
        <div class="row">
          <div class="icon">
            <img src="assets/icons/top-skills.svg">
          </div>
          <div class="data">
            <div class="title">
              Top Skills
            </div>
            <div class="description">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </div>
            <div class="space"></div>
            <quant-button type="button" label="Learn More" hierarchy="link-color" size="sm"
              [disabled]="false"></quant-button>
          </div>
        </div>
      </div>
      -->

        <!-- Resources -->
        <!--
      <div class="card">
        <div class="row">
          <div class="icon">
            <img src="assets/icons/resources.svg">
          </div>
          <div class="data">
            <div class="title">
              Resources
            </div>
            <div class="description">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </div>
            <div class="space"></div>
            <quant-button type="button" label="Learn More" hierarchy="link-color" size="sm"
              [disabled]="false"></quant-button>
          </div>
        </div>
      </div>
      -->

      </div>
    </qai-inner-wrap>

  </div>

  <!-- Footer -->
  <app-footer></app-footer>

  <!-- Previous results modal -->
  <app-previous-results-modal *ngIf="displayPreviousResults" [callUuid]="selectedCallUuid" [callType]="selectedCallType"
    [callName]="selectedCallName" [moduleAssignmentUuid]="moduleAssignmentUuid"
    [scoreCriteria]="assignment?.scoreCriteria || 0" [assignmentType]="assignment?.moduleAssignmentType"
    [call]="selectedCall" [callScoreCalcType]="selectedCall?.callScoreCalcType"
    (closePreviousResultsEvent)="closePreviousResultsModal()"></app-previous-results-modal>

  <app-screenshare-unsupported-modal
    [isVisible]="screenshareBlocked"
    [callName]="screenshareBlockedCallName"
    (closed)="closeScreenshareUnsupportedModal()">
  </app-screenshare-unsupported-modal>
